export enum BrandSegmentReportContextEnum {
  default = 0,
  inSegment,
  byBrand
}
